import React from 'react';
import { useEffect, useState } from 'react';
import MostrarServicios from './MostrarServicios';
import ContenedorAnimacion from './ContenedorAnimacion';
import ImageMarquee from './ImageMarquee';
import PartnersEditar from '../types/PartnersEditar';
import ObtenerPartners from '../functions/ObtenerPartners';
import buildImageSrc from '../functions/buildImageSrc';

import partner00 from '../assets/images/partners/partners_00_500.png';
import partner01 from '../assets/images/partners/partners_01_500.png';
import partner02 from '../assets/images/partners/partners_02_500.png';
import partner03 from '../assets/images/partners/partners_03_500.png';
import partner04 from '../assets/images/partners/partners_04_500.png';
import partner05 from '../assets/images/partners/partners_05_500.png';
import partner06 from '../assets/images/partners/partners_06_500.png';
import partner07 from '../assets/images/partners/partners_07_500.png';
import partner08 from '../assets/images/partners/partners_08_500.png';
import partner09 from '../assets/images/partners/partners_09_500.png';
import partner10 from '../assets/images/partners/partners_10_500.png';
import partner11 from '../assets/images/partners/partners_11_500.png';
import partner12 from '../assets/images/partners/partners_12_500.png';
import partner13 from '../assets/images/partners/partners_13_500.png';
import partner14 from '../assets/images/partners/partners_14_500.png';
import partner15 from '../assets/images/partners/partners_15_500.png';
import partner16 from '../assets/images/partners/partners_16_500_horizontal.png';


import { Link } from 'wouter';
import SearchIcon from '@mui/icons-material/Search';

interface PartnerImage {
    image: string;
    link: string;
}

const Servicios: React.FC<{ id: string }> = ({ id }) => {

    const [PartnersCargadosOk, setPartnersCargadosOk] = useState(false);
    const [PartnersData, setPartnersData] = useState<PartnersEditar[]>([]);
    const [PartnersCargados, setPartnersCargados] = useState<PartnersEditar[]>([]);
    const [PartnersImages, setPartnersImages] = useState<PartnerImage[]>([]);
    const [isLoading, setIsLoading] = useState(true);

    const mapPartnersToImages = (partners: PartnersEditar[]): PartnerImage[] => {
        return partners.map((partner) => ({
            image: buildImageSrc(partner.logo_mime, partner.logo_content) || "",
            link: partner.web || "#",
        }));
    };

    useEffect(() => {
        ObtenerPartners("activos_mostrables").then(data => {
            setPartnersData(data);
            setPartnersCargados(data.partners);
            setPartnersCargadosOk(true);
            const LocalPartnersImages: PartnerImage[] = mapPartnersToImages(data.partners);
            setPartnersImages(LocalPartnersImages);
            setIsLoading(false);
         });
    }, []);

    return (
        <section id={id} className="bg-white pt-[60px] min-h-screen">
            <div className="pt-8 pb-4 px-4 mx-auto max-w-screen-2xl text-center">
                <ContenedorAnimacion animation='slideInRight' duration={800} delay={1} className="">
                    <div className="mx-auto mb-6 max-w-screen-2xl">
                        <h2 className="font-metropolis mb-4 text-4xl tracking-tight font-regular text-gray-900 ">Servicios</h2>
                        <h3 className="font-metropolis font-regular text-gray-600 sm:text-xl ">Explorá nuestra gama de soluciones diseñadas para brindarte tranquilidad y seguridad.</h3>
                        <Link className="flex justify-center mt-4" to="/Buscador">
                                <button className="vp-btn-azul shadow-md shadow-vp-gris"><SearchIcon />Buscador de Servicios</button>
                        </Link>
                    </div> 
                </ContenedorAnimacion>
            </div>
            <div className="p-2 flex flex-col items-center xs:items-evenly">
                <MostrarServicios />
                <div className="flex flex-col mt-8 w-[90%] justify-center items-center">
                    <h2 className="font-metropolis text-4xl tracking-tight font-regular text-gray-900 ">Conocé a nuestros Partners</h2>
                    {isLoading ? (<p className="text-gray-500 mt-4">Cargando partners...</p>) : (<ImageMarquee images={PartnersImages} speed={60} />)}
                </div>
            </div>

        </section>
    );
};

export default Servicios;